import React from 'react'
import PropTypes from 'prop-types'
import { Positioning } from 'LiveBoard/components/shared/Positioning'
import { LeadingItem } from 'LiveBoard/components/mobile/LeadingItem'
import PositionRenderer from 'LiveBoard/components/shared/PositionRenderer'
import { Footer } from 'LiveBoard/components/shared/Footer'
import ItemsContainer from 'LiveBoard/containers/ItemsContainer'
import { LAYOUT_POSITION } from 'shared/constants'
import sortBy from 'lodash/sortBy'
import map from 'lodash/map'

import './style.css.scss'

const BoardContent = ({
  board,
  campaign: {
    themeColorHex,
    items: {
      show: showItems,
      title: positioningText,
      show_item_description: showItemDescription
    },
    footer,
    header
  },
  promotion: {
    items: promotion,
    show: showPromotion
  },
  sideBySide,
  onCategoryChange,
  leadingItem,
  hasLeadingItem,
  leadingItemAvailable,
  onItemClick,
  children
}) => {
  return (
    <section className="board-content-container">
      <div className="board-content">
        <PositionRenderer
          sideBySide={sideBySide}
          promotion={promotion}
          location={LAYOUT_POSITION.belowBanner}
          themeColorHex={themeColorHex}
          onItemClick={onItemClick}
          isMobile={true}
          showPromotion={showPromotion} />
        { showItems &&
            <Positioning
              config={{...positioningText}}
              board={board}
              themeColorHex={themeColorHex}
              hasLeadingItem={hasLeadingItem}
              leadingItem={leadingItem}
              leadingItemAvailable={leadingItemAvailable}
              showItemDescription={showItemDescription}
              leadingItemComponent={LeadingItem}
              onItemClick={onItemClick} />
        }
        <ItemsContainer
          onCategoryChange={onCategoryChange}
          showItemDescription={showItemDescription}
          onItemClick={onItemClick} >
          {children}
        </ItemsContainer>
        <PositionRenderer
          sideBySide={sideBySide}
          promotion={promotion}
          location={LAYOUT_POSITION.aboveFooter}
          themeColorHex={themeColorHex}
          onItemClick={onItemClick}
          isMobile={true}
          showPromotion={showPromotion} />
      </div>
      { footer.show && !footer.custom &&
        <Footer
          config={{...footer, headerLogo: header.logo}}
          themeColorHex={themeColorHex} />
      }
    </section>
  )
}

BoardContent.propTypes = {
  board: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  leadingItem: PropTypes.object,
  hasLeadingItem: PropTypes.bool.isRequired,
  leadingItemAvailable: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired
}

export default BoardContent
